import React, { useEffect, useState } from 'react'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import { Link } from 'react-router-dom';
import { Row } from 'reactstrap';
import axios from '../../API/axios';
import { ShimmerDiv } from 'shimmer-effects-react';
import LoginMobileHeader from '../../components/header/LoginMobileHeader';
import InstituteMobileHeader from '../../components/header/InstituteMobileHeader';
import CRMobileHeader from '../../components/header/CRMobileHeader';
import MobileHeader from '../../components/header/MobileHeader';
import LoginHeader from '../../components/header/LoginHeader';
import InstituteHeader from '../../components/header/InstituteHeader';
import CRHeader from '../../components/header/CRHeader';
import NonLoginHeader from '../../components/header/NonLoginHeader';


function Institute() {
  const [isLoading, setIsLoading] = useState(true);
  const [companyList, setCompanyList] = useState([]);
  const [institutes, setInstitutes] = useState([]);
  const [userList, setUserList] = useState([]);
  const [searchuserList, setSearchuserList] = useState([]);
  const [nextBatchLoading, setNextBatchLoading] = useState('')
  const [isError, setIsError] = useState(false);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(false);

  const getCompanyList = (page) => {
    setNextBatchLoading(true);

    const data = {
      pageNumber: page,
      pageSize: 10,
    };

    axios
      .post(`/Institute/GetAll?Search=${institutes}`, data)
      .then((response) => {
        const res = response.data.responseData.instituteProfiles;
        console.log("institutes", response.data.responseData.paging.totalPages);

        // setUserList(res)
        setIsLoading(false);
        setTotalPages(response.data.responseData.paging.totalPages);

        const newInstitute = response.data.responseData.instituteProfiles;
        console.log("newInstitute", newInstitute);

        if (institutes !== '') {
          setUserList([])
          setCompanyList(newInstitute)
        } else {
          setCompanyList([])
          setUserList((prev) => {
            const userSet = new Set(prev?.map((user) => user?.uid));
            const uniqueNewPosts = newInstitute.filter(
              (user) => !userSet.has(user?.uid)
            );
            return [...prev, ...uniqueNewPosts];
          });
        }

      })
      .catch((error) => {
        if (error.response && error.response.status === 404) {
          setIsError(true);
        } else {
          console.log(error);
        }
        setIsLoading(false);
        setNextBatchLoading(false);
      });
  };

  useEffect(() => {
    if (page <= totalPages) {
      getCompanyList(page + 1);
    }
  }, [page]);

  useEffect(() => {
    setUserList([]); // Reset user list when searchUserName changes
    getCompanyList(1, institutes); // Start from page 1 for a new search
  }, [institutes]);

  const handleInfiniteScroll = async () => {
    try {
      if (window.innerHeight + document.documentElement.scrollTop + 1 >=
        document.documentElement.scrollHeight) {
        setLoading(true);
        console.log('log', page, totalPages);

        page < totalPages && setPage((prev) => prev + 1);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleInfiniteScroll);
    return () => window.removeEventListener("scroll", handleInfiniteScroll);
  }, []);

  const [isShowMobile, setShowMobile] = useState(false);

  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };

  const module = localStorage.getItem('Module')

  return (
    <>
    {module === 'Candidate' ? <LoginMobileHeader handleMobile={handleMobile} /> :
        module === 'Institution' ? <InstituteMobileHeader handleMobile={handleMobile} /> :
          module === 'Company' ? <CRMobileHeader handleMobile={handleMobile} /> :
            module === 'Recruiter' ? <CRMobileHeader handleMobile={handleMobile} /> :
              <MobileHeader handleMobile={handleMobile} />}

      {module === 'Candidate' ? <LoginHeader clname="managejobs" handleMobile={handleMobile} /> :
        module === 'Institution' ? <InstituteHeader clname="managejobs" handleMobile={handleMobile} /> :
          module === 'Company' ? <CRHeader clname="managejobs" handleMobile={handleMobile} /> :
            module === 'Recruiter' ? <CRHeader clname="managejobs" handleMobile={handleMobile} /> :
              <NonLoginHeader clname="managejobs" handleMobile={handleMobile} />}



    <div className="pt-70">
    <section className={`inner-employer-section PeopleSearch pt-5`}>
      <div className="container">
        <Tabs className="col-lg-12 tf-tab">
          <Row>
            <div className="wd-meta-select-job">
              <div className="wd-findjob-filer">
                <div className="group-select-display"></div>
                <div className="form-group-1">
                  <input
                    type="email"
                    className="form-control p-2 Dark-Input-from-group"
                    id="exampleInputEmail1"
                    aria-describedby="emailHelp"
                    placeholder="Search Institute"
                    onChange={(e) => {
                      setInstitutes(e.target.value);
                      getCompanyList();
                    }}
                    value={institutes}
                  />
                </div>
              </div>
            </div>
          </Row>
  
          <div className="content-tab">
            {/* Tab content for employer listings */}
            <TabPanel
              className="inner"
              style={{
                minHeight: isLoading || nextBatchLoading ? '600px' : 'auto',
                height: 'auto',
              }}
            >
              <div className="group-col-2">
                {isLoading ? (
                  <div className="row mt-2">
                    {[...Array(6)].map((_, i) => (
                      <div key={i} className="col-md-6 mt-2">
                        <ShimmerDiv mode="light" height={400} width="100%" />
                      </div>
                    ))}
                  </div>
                ) : isError ? (
                  <div className="mt-2 error-image-cont error-cont">
                    {/* Error State */}
                    <p>Error fetching data. Please try again.</p>
                  </div>
                ) : companyList.length === 0 && userList.length > 0 ? (
                  userList.map((institute, index) => (
                    <div key={index} className="employer-block style-2 cl2">
                      <div className="inner-box">
                        <div className="logo-company">
                          <img src={institute.logoImage} alt="jobtex" />
                        </div>
                        <div className="box-content">
                          <h3>
                            <Link>{institute.name}</Link>
                          </h3>
                          <p className="info">
                            <span className="icon-map-pin"></span>
                            {institute.cityName}
                          </p>
                        </div>
                        <div className="button-readmore">
                          <button className="btn-employer">Follow</button>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  companyList.map((institute, index) => (
                    <div key={index} className="employer-block style-2 cl2">
                      <div className="inner-box">
                        <div className="logo-company">
                          <img src={institute.logoImage} alt="jobtex" />
                        </div>
                        <div className="box-content">
                          <h3>
                            <Link>{institute.name}</Link>
                          </h3>
                          <p className="info">
                            <span className="icon-map-pin"></span>
                            {institute.cityName}
                          </p>
                        </div>
                        <div className="button-readmore">
                          <button className="btn-employer">Follow</button>
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </TabPanel>
          </div>
        </Tabs>
      </div>
    </section>
    </div>

    </>

  );
}  
export default Institute